module.exports = __webpack_public_path__ + "img/knu2_gallery1.f3c2358d.jpg";